import { render, staticRenderFns } from "./supplierCouponList.vue?vue&type=template&id=3ef2882e&scoped=true"
import script from "./supplierCouponList.vue?vue&type=script&lang=js"
export * from "./supplierCouponList.vue?vue&type=script&lang=js"
import style0 from "./supplierCouponList.vue?vue&type=style&index=0&id=3ef2882e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef2882e",
  null
  
)

export default component.exports